export const LOGIN_PATH = "/";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const RESET_PASSWORD_PATH = "/reset-password";

export const ACCOUNT_PATH = "/account";

export const DASHBOARD_PATH = "/";

export const PARTNERS_PATH = "/promotions/partners";
export const PARTNERS_ADD_PATH = "/promotions/partners/add-or-update";
export const PARTNERS_UPDATE_PATH = "/promotions/partners/add-or-update/:id";

export const OFFERS_PATH = "/promotions/offers";
export const OFFERS_ADD_PATH = "/promotions/offers/add-or-update";
export const OFFERS_UPDATE_PATH = "/promotions/offers/add-or-update/:id";

export const PRODUCT_PATH = "/promotions/product";
export const PRODUCT_ADD_PATH = "/promotions/product/add-or-update";
export const PRODUCT_UPDATE_PATH = "/promotions/product/add-or-update/:id";

export const RAFFLE_PATH = "/loyalty/raffles";
export const RAFFLE_ADD_PATH = "/loyalty/raffles/add-or-update";
export const RAFFLE_UPDATE_PATH = "/loyalty/raffles/add-or-update/:id";

export const LEADERBOARD_CONFIGURATIONS_PATH =
  "/loyalty/leaderboard-configurations";
export const LEADERBOARD_CONFIGURATIONS_ADD_PATH =
  "/loyalty/leaderboard-configurations/add-or-update";
export const LEADERBOARD_CONFIGURATIONS_UPDATE_PATH =
  "/loyalty/leaderboard-configurations/add-or-update/:id";
export const LEADERBOARDS_LIST_PATH =
  "/loyalty/leaderboard-configurations/leaderboards";
export const LEADERBOARDS_PATH =
  "/loyalty/leaderboard-configurations/leaderboards/:id";
export const LEADERBOARD_WINNERS_LIST_PATH =
  "/loyalty/leaderboard-configurations/leaderboards/winners";
export const LEADERBOARD_WINNERS_PATH =
  "/loyalty/leaderboard-configurations/leaderboards/winners/:id";
export const LEADERBOARD_MEMBERS_LIST_PATH =
  "/loyalty/leaderboard-configurations/leaderboards/members";
export const LEADERBOARD_MEMBERS_PATH =
  "/loyalty/leaderboard-configurations/leaderboards/members/:id";

export const PRIZES_PATH = "/loyalty/leaderboard-configurations/prizes";
export const PRIZES_ADD_PATH =
  "/loyalty/leaderboard-configurations/prizes/add-or-update";
export const PRIZES_UPDATE_PATH =
  "/loyalty/leaderboard-configurations/prizes/add-or-update/:id";

export const STEPS_CONFIG_PATH = "/loyalty/steps-config";

export const TEXT_PAGE_PATH = "/content-management/text-pages";
export const TEXT_PAGE_ADD_PATH =
  "/content-management/text-pages/add-or-update";
export const TEXT_PAGE_UPDATE_PATH =
  "/content-management/text-pages/add-or-update/:id";

export const WIDGET_CONFIG_PATH = "/content-management/widget-config";

export const BANNERS_PATH = "/content-management/banners";
export const BANNERS_ADD_PATH = "/content-management/banners/add-or-update";
export const BANNERS_UPDATE_PATH =
  "/content-management/banners/add-or-update/:id";

export const CUSTOMERS_PATH = "/user-management/customers";
export const CUSTOMERS_DETAIL_PATH = "/user-management/customers/detail";
export const CUSTOMERS_DETAIL_ID_PATH = "/user-management/customers/detail/:id";

export const TRANSACTIONS_PATH = "/user-management/transactions";

export const CUSTOMER_EXPORT_PATH = "/user-management/customer-export";

export const CODE_GENERATION_PATH = "/code-management/code-generation";
export const CODE_GENERATION_DETAIL_PATH =
  "/code-management/code-generation/detail";
export const CODE_GENERATION_DETAIL_ID_PATH =
  "/code-management/code-generation/detail/:id";

export const CODE_CHECKER_PATH = "/code-verification/code-checker";

export const SYSTEM_USERS_PATH = "/system-users/system-users";
export const SYSTEM_USERS_ADD_PATH = "/system-users/system-users/add-or-update";
export const SYSTEM_USERS_UPDATE_PATH =
  "/system-users/system-users/add-or-update/:id";

export const APP_UPDATE_CONFIG_ANDROID_PATH =
  "/config/application-config/android/add-or-update";
export const APP_UPDATE_CONFIG_IOS_PATH =
  "/config/application-config/ios/add-or-update";

export const REFERRAL_CONFIG_PATH = "/referral/referral-config";

export const GAME_CONFIG_PATH = "/games-management/game-config";

export const GAMES_PATH = "/games-management/games";
export const GAMES_ADD_PATH = "/games-management/games/add-or-update";
export const GAMES_UPDATE_PATH = "/games-management/games/add-or-update/:id";

export const NOTIFICATION_TEMPLATES_PATH =
  "/notifications/notification-templates";
export const NOTIFICATION_TEMPLATES_ADD_PATH =
  "/notifications/notification-templates/add-or-update";
export const NOTIFICATION_TEMPLATES_UPDATE_PATH =
  "/notifications/notification-templates/add-or-update/:id";

export const BLITZ_QUIZ_PATH = "/loyalty/blitz-quiz";
export const BLITZ_QUIZ_ADD_PATH = "/loyalty/blitz-quiz/add-or-update";
export const BLITZ_QUIZ_UPDATE_PATH =
  "/loyalty/blitz-quiz/add-or-update/:id";

export const CHALLENGES_PATH = "/loyalty/challenges";
export const CHALLENGES_ADD_PATH = "/loyalty/challenges/add-or-update";
export const CHALLENGES_UPDATE_PATH = "/loyalty/challenges/add-or-update/:id";

export const INFLUENCERS_CAMPAIGN_PATH = "/loyalty/influencers-campaign";
export const INFLUENCERS_CAMPAIGN_ADD_PATH =
  "/loyalty/influencers-campaign/add-or-update";
export const INFLUENCERS_CAMPAIGN_UPDATE_PATH =
  "/loyalty/influencers-campaign/add-or-update/:id";

export const SALES_POINT_PATH = "/instant-win/sales-point";
export const SALES_POINT_ADD_PATH = "/instant-win/sales-point/add-or-update";
export const SALES_POINT_UPDATE_PATH =
  "/instant-win/sales-point/add-or-update/:id";

export const SALES_POINT_GROUP_PATH = "/instant-win/sales-point-group";
export const SALES_POINT_GROUP_ADD_PATH =
  "/instant-win/sales-point-group/add-or-update";
export const SALES_POINT_GROUP_UPDATE_PATH =
  "/instant-win/sales-point-group/add-or-update/:id";

export const INSTANT_WIN_CAMPAIGN_PATH = "/instant-win/campaign";
export const INSTANT_WIN_CAMPAIGN_ADD_PATH =
  "/instant-win/campaign/add-or-update";
export const INSTANT_WIN_CAMPAIGN_UPDATE_PATH =
  "/instant-win/campaign/add-or-update/:id";

export const INSTANT_WIN_PAYOUTS_PATH = "/instant-win/payouts";
export const INSTANT_WIN_PAYOUTS_DETAIL_PATH = "/instant-win/payouts/detail";
export const INSTANT_WIN_PAYOUTS_DETAIL_ID_PATH =
  "/instant-win/payouts/detail/:id";

export const PRIZE_LIBRARY_PATH = "/loyalty/prize-library";
export const PRIZE_LIBRARY_ADD_PATH = "/loyalty/prize-library/add-or-update";
export const PRIZE_LIBRARY_UPDATE_PATH =
  "/loyalty/prize-library/add-or-update/:id";
